function escapeRegExp(string) {
  // When special characters are used in custom field label. We need to escape them when using regex
  // Else it'll throw error saying
  // Uncaught SyntaxError: Invalid regular expression: /${label}/: Unmatched') at String.match
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export const getSubjectPlaceholdersObj = (
  inputString = '',
  placeholdersList = []
) => {
  const placeholdersInString = placeholdersList.filter((placeholder) => {
    const escapedLabel = escapeRegExp(`#${placeholder.label}`);
    return inputString.match(escapedLabel);
  });
  const subjectMentions = placeholdersInString.reduce((acc, placeholder) => {
    acc[placeholder.id] = placeholder.label;
    return acc;
  }, {});

  return subjectMentions;
};
